import { ProjectListItem } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { PROJECT_LIST } from '../apis';

const defaultValue: ProjectListItem[] = [];

async function getProjectList(): Promise<ProjectListItem[]> {
  return axios
    .get(PROJECT_LIST)
    .then((res) => res.data.data)
    .catch(() => defaultValue);
}

export function useProjectList() {
  return useQuery<ProjectListItem[]>({
    queryKey: ['get-project-list'],
    queryFn: () => getProjectList(),
  });
}

export default useProjectList;
